export class Fav {
	constructor() {}

	toggleFav(itemId, parent) {
		var el = $(parent)

		if (el.hasClass("current")) var action = "del"
		else var action = "add"

		$.ajax({
			url: "/ajax.php?mid=20",
			type: "POST",
			data: {
				action: action,
				item_id: itemId,
			},
			dataType: "json",
			success: function(res) {
				if (res["success"]) {
					$(".header-panel__like-quantity").text(res["new_count"])
					if (res["new_count"])
						$(".header-panel__like-quantity").addClass("full")
					else $(".header-panel__like-quantity").removeClass("full")

					if (res["added"]) {
						el.addClass("current")
						el.find("span").text("Убрать из избранного")
						//ga('send', 'event', 'fav', 'add', itemId);
					} else {
						el.removeClass("current")
						el.find("span").text("Добавить в избранное")
						el.blur()
					}
				} else {
					swal(res["error"])
				}
			},
			error: function(err) {
				swal("Ошибка! Попробуйте повотрить запрос. Error: " + err)
			},
		})
	}
}
